<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { onSettingsResponse } from '../../../helpers/device_settings_helpers';
	import { postReq } from 'src/services/http';
	//Stores
	import { devices } from 'src/stores/lists/devices';
	//Design system components
	import { Toggle, ToggleV2 } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from '../../../types/Device';
	import SettingGuide from '../SettingGuide.svelte';
	import { push } from 'svelte-spa-router';
	import { setSidePanelState } from 'src/components/Sidepanel/sidepanel-helpers';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let device: Device;

	const id = device.id,
		save = async () => {
			const newCheckedValue = !checked;
			const exclude_event_log = newCheckedValue;

			const res = await postReq('interface/device/set_cloud_options', {
				id: device.id,
				set: 'exclude_event_log',
				val: exclude_event_log,
			});

			if (res.isok) {
				if (!device.cloud_options) {
					device.cloud_options = {};
				}
				device.cloud_options.exclude_event_log = exclude_event_log;
				devices.update(device);
				checked = newCheckedValue;
				initCheckedState = exclude_event_log;
			}
			const toastTexts = {
				success: $format('event_log_scc_toast', {
					default: 'Event log exclusion settings changed.',
				}),
				danger: $format('event_log_err_toast', {
					default: 'Failed to change event log exclusion settings!',
				}),
			};
			onSettingsResponse(res, device, toastTexts);
		};

	let checked =
			$devices[id]?.cloud_options?.exclude_event_log || $devices[id]?.exclude_event_log || false,
		initCheckedState = checked;

	const openActivityLog = () => {
		setSidePanelState({
			type: 'device',
			id: device.id,
			open: false,
			showSettingsModal: false,
		});
		push('/event_log');
	};

	$: ToggleC = $showNewLayout ? ToggleV2 : Toggle;
</script>

<SettingGuide
	text={$format('settings_guide_exclude_event_log', {
		default:
			'Stop this device from appearing in the global activity log. Events will not show up there while this is on.',
	})}
	linkText={$format('settings_link_activity_log', { default: 'Open the activity log' })}
	on:click={openActivityLog}
/>

<svelte:component this={ToggleC} {checked} size="m" on:click={save} id="toggle-66wv9cg">
	{$format('toggle_exclude_from_global_activity_log', {
		default: 'Disable event log reports for this device.',
	})}
</svelte:component>
